import * as React from 'react';
import Icon from 'components/Icon';
import Button from 'components/Button';
import { t } from '@lingui/core/macro';

export interface Stream3DErrorScreenProps {
  onRetry: () => void;
}

export const Stream3DErrorScreen: React.FC<Stream3DErrorScreenProps> = ({ onRetry }) => {
  return (
    <div
      className="ex3d-brand-page-background flex size-full flex-col items-center justify-center gap-4"
      data-testid="stream-3d-error-screen"
    >
      <Icon className="ex3d-icon--warning size-8" />
      <h1 className="text-xl font-bold">{t`No 3D instances available`}</h1>
      <p>{t`The 3D experience cannot be started at this time.`}</p>
      <Button
        text={t`Retry Connection`}
        onClick={onRetry}
        data-testid="retry-3d-connection"
        className="mt-4 rounded-3xl border border-white bg-white px-6 py-3 text-teal-dark hover:bg-gray-100"
        icon="ex3d-icon--update"
        svgClassName="size-4 bg-teal-dark"
      />
    </div>
  );
};

Stream3DErrorScreen.displayName = 'Stream3DErrorScreen';
